import React from "react";
import { RecipeHistoryItem } from "../../../../api/recipeSimulator";

interface ChangeHistoryItemProps {
  item: RecipeHistoryItem;
  formatDate: (date?: string) => string;
  getOperationLabel: (operation: string) => string;
}

const ChangeHistoryItemComponent: React.FC<ChangeHistoryItemProps> = ({
  item,
  formatDate,
  getOperationLabel
}) => {
  return (
    <div key={item.id} className="tw-border tw-border-secondary tw-rounded-md tw-bg-secondary/20 tw-px-3.5 tw-py-2.5 tw-space-y-1.5">
      <div className="tw-space-y-0.5">
        <p className="tw-text-xs tw-text-muted-foreground tw-font-mono">{formatDate(item.changedAt)}</p>
        <p className="tw-text-sm tw-text-foreground">
          <span className="tw-font-medium">{item.changedBy?.name || "System"}</span>{" "}
          {getOperationLabel(item.operation)}
        </p>
      </div>

      {/* Changes Details */}
      {item.changes && item.changes.length > 0 && (
        <div className="tw-rounded-md tw-border tw-border-secondary/40 tw-divide-y tw-divide-secondary/40 tw-max-h-80 tw-overflow-y-auto tw-bg-background">
          {item.changes.map((change: any, idx: number) => (
            <div key={idx} className="tw-text-xs tw-p-2 tw-flex tw-items-center tw-gap-2 tw-justify-between">
              <p className="tw-font-medium tw-text-foreground tw-flex-1">{change.field}</p>
              <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-muted-foreground">
                <span className="tw-px-1.5 tw-py-0.5 tw-rounded tw-text-xs tw-bg-warning/10 tw-text-warning">
                  {change.before === "N/A" || change.before === undefined || change.before === null
                    ? "N/A"
                    : typeof change.before === "number"
                    ? change.before.toFixed(2)
                    : change.before}
                </span>
                <span className="tw-text-xs">→</span>
                <span className="tw-px-1.5 tw-py-0.5 tw-rounded tw-text-xs tw-bg-success/10 tw-text-success">
                  {change.after === undefined || change.after === null
                    ? "N/A"
                    : typeof change.after === "number"
                    ? change.after.toFixed(2)
                    : change.after}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChangeHistoryItemComponent;
